module.exports = __webpack_public_path__ + "img/hotpicklotto_black.17f4b502.png";